import tours from './tours';

export const ONBOARD_DASHBOARD = tours.ONBOARD_DASHBOARD

